<template>
    <div class="p-5 darker">

        <div class="col-md-12 text-right mb-4">
            <input type="submit" value="Save" class="btn widest ml-auto" @click="save">
        </div>

        <!-- accodion 1 -->
        <div v-if="accordions[0].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(0)">
            <span class="darker font-weight-600">Check-in</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[0].isOpen}"></i>
        </div>
        <div v-if="accordions[0].isOpen && accordions[0].enabled" class="row mb-4">

            <div class="col-md-4 mb-2">
                <label class="full">
                    Location to check-in
                    <input type="text" class="bg-lighter" v-model="presets.location.name">
                </label>
            </div>

            <div class="col-md-3 mb-2">
                <label class="full">
                    Latitude
                    <input type="text" class="bg-lighter" v-model="presets.location.latitude">
                </label>
            </div>

            <div class="col-md-3 mb-2">
                <label class="full">
                    Longitude
                    <input type="text" class="bg-lighter" v-model="presets.location.longitude">
                </label>
            </div>

            <!-- <div class="col-md-4 mb-2">
                <label class="full">
                    Time for Check-in
                    <input type="text" class="bg-lighter" v-model="presets.time">
                </label>
            </div> -->

            <!-- <div class="col-md-2 mb-2">
                <label class="full">
                    Time before event
                </label>
                <div class="d-flex">
                    <timepicker format="hh:mm" :showOnTop="false" @change="setTimeBeforeEvent"></timepicker>
                </div>
            </div> -->

        </div>

        <!-- accodion 2 -->
        <div v-if="accordions[1].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(1)">
            <span class="darker font-weight-600">Direct Sales - Payment and Deposit</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[1].isOpen}"></i>
        </div>
        <div v-if="accordions[1].isOpen && accordions[1].enabled" class="mb-4">

            <!-- <div class="row mb-4">
                <div class="col-md-6 d-flex justify-content-end">
                    <div class="d-flex align-items-center  w-100">
                        <label class="full darkest">
                        Charge total amount for product higher than &nbsp;
                        </label>
                        <div class="d-flex ml-2">
                            <input class="glued-right bg-lighter" style="width: 80px;" type="number" v-model="presets.chargeTotalAmount">
                            <div class="glued-left dark">€</div>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="row mb-4">
                <div class="col-md-6">
                    <label class="full">
                        Payment
                    </label>
                    <v-select v-model="paymentDepositType" :options="getRequirePaymentOptions"  @input="setPaymentDepositType" label="description"></v-select>
                </div>

                <div class="col-md-4" v-if="presets.paymentDepositType && presets.paymentDepositType == 2">
                    <label class="full">
                        Deposit
                    </label>
                    <v-select v-model="depositType" :options="getDepositOptions" @input="setDepositType" label="description"></v-select>
                    <span class="fs-smaller dark">This is the deposit that the customer must pay at the time of booking.</span>
                </div>

                <div class="col-md-2 mb-2 d-flex justify-content-end" v-if="presets.paymentDepositType && presets.paymentDepositType == 2 && depositType && depositType.id != 2">
                    <label class="full">
                        Amount
                        <div class="d-flex">
                            <input class="glued-right bg-lighter" type="number" v-model="presets.depositValue">
                            <div class="glued-left" v-if="presets.depositType == 0">€</div>
                            <div class="glued-left" v-if="presets.depositType == 1">%</div>
                        </div>
                    </label>
                </div>

            </div>



            <!-- <div class="row">
                <div class="col-md-6 mb-2">
                    <div class="d-flex align-items-start align-self-end">
                        <label class="full darkest">
                            <span>Limit period to payment confirmation after booking.</span>
                        </label>
                        <input class="ml-1 bg-lighter w-25" type="text" v-model="presets.paymentPeriodLimit">
                    </div>
                    <div>
                        <span class="fs-smaller dark w-100">After this period reservation withouth payment confirmation can be canceled.</span>
                    </div>
                </div>

            </div> -->

        </div>

        <!-- accodion 3 -->
        <div v-if="accordions[2].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(2)">
            <span class="darker font-weight-600">Cancellation rules</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[2].isOpen}"></i>
        </div>
        <div v-if="accordions[2].isOpen && accordions[2].enabled" class="mb-4">

            <div class="row mb-5 mt-4">
                <div class="col-md-12 darker font-weight-600">Time before event for automatic cancellation:</div>
            </div>

            <div class="row px-5 mb-3">
                <div class="col-sm-4">Direct - In person</div>
                <div class="col-sm-3 d-flex">
                    <input class="glued-right w-50 bg-lighter" type="number">
                    <v-select class="w-50" value="Minutes" :options="['Minutes', 'Hours']"></v-select>
                </div>
            </div>

            <div class="row px-5 mb-3">
                <div class="col-sm-4">Phone</div>
                <div class="col-sm-3 d-flex">
                    <input class="glued-right w-50 bg-lighter" type="number">
                    <v-select class="w-50" value="Minutes" :options="['Minutes', 'Hours']"></v-select>
                </div>
            </div>

            <div class="row px-5 mb-3">
                <div class="col-sm-4">Email</div>
                <div class="col-sm-3 d-flex">
                    <input class="glued-right w-50 bg-lighter" type="number">
                    <v-select class="w-50" value="Minutes" :options="['Minutes', 'Hours']"></v-select>
                </div>
            </div>

            <div class="row px-5 mb-3">
                <div class="col-sm-4">Website</div>
                <div class="col-sm-3 d-flex">
                    <input class="glued-right w-50 bg-lighter" type="number">
                    <v-select class="w-50" value="Minutes" :options="['Minutes', 'Hours']"></v-select>
                </div>
            </div>

        </div>

        <!-- accodion 4 -->
        <div v-if="accordions[3].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(3)">
            <span class="darker font-weight-600">Commissions</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[3].isOpen}"></i>
        </div>
        <div v-if="accordions[3].isOpen && accordions[3].enabled" class="mb-4">

            <div class="row px-5 mb-3 align-items-start">
                <div class="col-md-6 row">

                    <div class="col-md-12 darkest font-weight-600">Agents</div>

                    <div class="row m-0 align-items-center w-100">
                        <div class="col-md-8"></div>
                        <div class="col-md-4 dark font-weight-600 fs-small text-center">
                            Commission
                        </div>
                    </div>

                    <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            Products - Commission by default
                        </div>
                        <div class="col-sm-4 d-flex justify-content-center">
                            <input class="glued-right w-50 bg-lighter" type="number" v-model="presets.commissionAgentsProduct">
                            <div class="glued-left dark w-25">%</div>
                        </div>
                    </div>

                    <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            Extras - Commission by default
                        </div>
                        <div class="col-sm-4 d-flex justify-content-center">
                            <input class="glued-right w-50 bg-lighter" type="number" v-model="presets.commissionAgentsComponent">
                            <div class="glued-left dark w-25">%</div>
                        </div>
                    </div>

                    <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            Pickups - Commission by default
                        </div>
                        <div class="col-sm-4 d-flex justify-content-center">
                            <input class="glued-right w-50 bg-lighter" type="number" v-model="presets.commissionAgentsTransport">
                            <div class="glued-left dark w-25">%</div>
                        </div>
                    </div>

                    <!-- <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            <div>
                                Allows to create reservations for others
                            </div>
                            <div class="dark fs-smaller">
                                Commission will be registered wirh the name of selected seller.
                            </div>

                        </div>
                        <div class="col-sm-4 d-flex justify-content-end">
                            <toggle-button class="mr-3" :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                        </div>
                    </div>

                    <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            <div>
                                Commission includes IVA
                            </div>

                        </div>
                        <div class="col-sm-4 d-flex justify-content-end">
                            <toggle-button class="mr-3" :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                        </div>
                    </div>

                    <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            <div>
                                Exclude pickups from comissions
                            </div>

                        </div>
                        <div class="col-sm-4 d-flex justify-content-end">
                            <toggle-button class="mr-3" :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                        </div>
                    </div> -->


                </div>

                <div class="col-md-6 row" >

                    <div class="col-md-12 darkest font-weight-600">My Team - Sellers</div>

                    <div class="row m-0 align-items-center w-100">
                        <div class="col-md-8"></div>
                        <div class="col-md-4 dark font-weight-600 fs-small text-center">
                            Commission
                        </div>
                    </div>

                    <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            Products - Commission by default
                        </div>
                        <div class="col-sm-4 d-flex justify-content-center">
                            <input class="glued-right w-50 bg-lighter" type="number"  v-model="presets.commissionMyTeamProduct">
                            <div class="glued-left dark w-25">%</div>
                        </div>
                    </div>

                    <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            Extras - Commission by default
                        </div>
                        <div class="col-sm-4 d-flex justify-content-center">
                            <input class="glued-right w-50 bg-lighter" type="number"  v-model="presets.commissionMyTeamComponent">
                            <div class="glued-left dark w-25">%</div>
                        </div>
                    </div>

                    <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            Pickups - Commission by default
                        </div>
                        <div class="col-sm-4 d-flex justify-content-center">
                            <input class="glued-right w-50 bg-lighter" type="number"  v-model="presets.commissionMyTeamTransport">
                            <div class="glued-left dark w-25">%</div>
                        </div>
                    </div>



                </div>

            </div>

        </div>

        <!-- accodion 5 -->
        <div v-if="accordions[4].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(4)">
            <span class="darker font-weight-600">Discounts</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[4].isOpen}"></i>
        </div>
        <div v-if="accordions[4].isOpen && accordions[4].enabled" class="mb-4">

            <div class="col-md-6 row">

                <!-- <div class="row m-0 align-items-center w-100 mt-5">
                    <div class="col-md-8"></div>
                    <div class="col-md-4 dark font-weight-600 fs-small text-center">
                        Commission
                    </div>
                </div>

                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        Maximum discount for sellers from my team
                    </div>
                    <div class="col-sm-4 d-flex justify-content-center">
                        <input class="glued-right w-50 bg-lighter" type="number">
                        <div class="glued-left dark w-25">%</div>
                    </div>
                </div> -->

                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        Exclude transport from discounts
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <toggle-button class="mr-3" v-model="presets.excludeTransportFromDiscounts" :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>

                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        Exclude extras from discounts
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <toggle-button class="mr-3" v-model="presets.excludeExtraFromDiscounts" :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>


            </div>


        </div>

        <!-- accodion 6 -->
        <div v-if="accordions[5].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(5)">
            <span class="darker font-weight-600">Agents Permissions</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[5].isOpen}"></i>
        </div>
        <div v-if="accordions[5].isOpen && accordions[5].enabled" class="mb-4">

            <div class="col-md-6 row">

                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        Agents have access to Extras
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <!-- work in progress, not connected, add v-model -->
                        <toggle-button class="mr-3" v-model="presets.agentsHaveAccessExtras"  :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>

                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        Agents have access to Pickups
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <!-- work in progress, not connected, add v-model -->
                        <toggle-button class="mr-3" v-model="presets.agentsHaveAccessPickups"  :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>

            </div>

        </div>

        <!-- accodion 7 -->
        <div v-if="accordions[6].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(6)">
            <span class="darker font-weight-600">Widget Permissions</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[6].isOpen}"></i>
        </div>
        <div v-if="accordions[6].isOpen && accordions[6].enabled" class="mb-4">

            <div class="col-md-6 row">

                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        Widget have access to Extras
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <!-- work in progress, not connected, add v-model -->
                        <toggle-button class="mr-3" v-model="presets.widgetHaveAccessExtras"  :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>

                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        Widget have access to Pickups
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <!-- work in progress, not connected, add v-model -->
                        <toggle-button class="mr-3" v-model="presets.widgetHaveAccessPickups"  :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>

            </div>

        </div>

        <!-- accodion 8 -->
        <div v-if="accordions[7].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(7)">
            <span class="darker font-weight-600">Sales</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[7].isOpen}"></i>
        </div>
        <div v-if="accordions[7].isOpen && accordions[7].enabled" class="mb-4">

            <div class="row mb-4">
                <div class="col-md-6 d-flex justify-content-end">
                    <div class="d-flex align-items-center  w-100">
                        <label class="full darkest">
                        Charge total amount for product higher than &nbsp;
                        </label>
                        <div class="d-flex ml-2">
                            <input class="glued-right bg-lighter" style="width: 80px;" type="number" v-model="presets.chargeTotalAmount">
                            <div class="glued-left dark">€</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- <div class="col-md-12 text-right mb-4">
            <input type="submit" value="Save" class="btn widest ml-auto" @click="save">
        </div> -->

    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    import {mapGetters, mapActions} from 'vuex'
    import Timepicker from '@/tools/Timepicker'

    export default {
        data: function() {
            return {
                accordions:[
                    {
                        id:1, //ids ore not being used for anything
                        isOpen: true,
                        enabled: false
                    },
                    {
                        id:2,
                        isOpen: true,
                        enabled: true
                    },
                    {
                        id:3,
                        isOpen: true,
                        enabled: false
                    },
                    {
                        id:4,
                        isOpen: true,
                        enabled: false
                    },
                    {
                        id:5,
                        isOpen: true,
                        enabled: true
                    },
                    {
                        id:6,
                        isOpen: true,
                        enabled: false
                    },
                    {
                        id:7,
                        isOpen: true,
                        enabled: false
                    },
                    {
                        id:8,
                        isOpen: true,
                        enabled: true
                    }
                ],
                paymentDepositType: null,
                depositType: null
            }
        },
        created: function() {
            this.getPaymentOptions()
            this.setCorrectDepositPosition()
        },
        computed: {
            ...mapGetters([
                'getDepositOptions',
                'getRequirePaymentOptions'
            ])
        },
        methods:{
            ...mapActions([
                'saveSettingsPresets'
            ]),
            toggleAccordion: function(index){
                // for(var accordionIndex in this.accordions){
                //     if(accordionIndex != index){
                //         this.accordions[accordionIndex].isOpen = false;
                //     }
                // }
                this.accordions[index].isOpen ^= true;
            },
            save: function(){
                // this.$emit('save');
                this.saveSettingsPresets(this.presets)
            },
            getPaymentOptions: function() {

                if(this.presets.paymentDepositType == null){
                    this.presets.paymentDepositType = this.getRequirePaymentOptions[0]
                } else {
                    for(let paymentDepositType of this.getRequirePaymentOptions){
                        if(paymentDepositType.id == this.presets.paymentDepositType){
                            this.paymentDepositType = paymentDepositType
                        }
                    }
                }
            },
            // getDepositOptions: function() {
            //     axios.get('/api/settings/GetDepositTypeList').then(response => {
            //         if(response.status == 200){
            //             this.depositOptions = response.data
            //
            //             //if there is now option selected we set it as the first option
            //             if(this.presets.depositType == null){
            //                 this.presets.depositType = response.data[0]
            //             } else {
            //                 for(let depositType of response.data){
            //                     if(depositType.id == this.presets.depositType){
            //                         this.depositType = depositType
            //                     }
            //                 }
            //             }
            //
            //         }
            //     })
            // },
            setCorrectDepositPosition: function () {
                //if there is now option selected we set it as the first option
                if(this.presets.depositType == null){
                    this.presets.depositType = this.getDepositOptions[0]
                } else {
                    for(let depositType of this.getDepositOptions){
                        if(depositType.id == this.presets.depositType){
                            this.depositType = depositType
                        }
                    }
                }
            },
            setTimeBeforeEvent: function(e) {
                this.presets.timeBeforeEvent = e + ":00"
            },
            setDepositType: function(e) {
                this.presets.depositType = e.id
            },
            setPaymentDepositType: function(e) {
                this.presets.paymentDepositType = e.id
            }
        },
        props:['presets'],
        components:{
            vSelect: extendedVSelect,
            Timepicker
        }
    }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// TabPresets.vue?f84cc7f0